import React, { PropsWithChildren, useEffect, useState } from "react";
import "Common.css";
import "Components/AdlServices.css";
import { TextDropdown } from "Components/TextDropdown";
import { Div, Txt } from "Components/GenericView";
import { UNDEF } from "Constants";
import { OTHERS } from "DataConstants";
import { MedicalServicesProps } from "./types";
// Assuming the type of 'medicalList' is an array of objects with 'group_name' and 'conditions' properties
type MedicalGroup = {
  group_name: string;
  conditions: string[]; // Adjust the type here based on the actual type of 'conditions'
};

const MedicalServices = (props: PropsWithChildren<MedicalServicesProps>) => {
  const [_tempMedical, set_tempMedical] = useState<string[]>([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to track dropdown open/close

  const {
    medical_conditions,
    medicalList,
    onMedicalChange,
    value,
    readOnly: isViewOnly,
    hidemedical,
  } = props;

  const _cleanup = () => {
    set_tempMedical([]);
  };

  const _deleteMedical = (item: string) => {
    let filteredMedical = (_tempMedical || []).filter((medical: any) => medical !== item);
    set_tempMedical(filteredMedical);
    onMedicalChange && onMedicalChange(filteredMedical);
  };

  const _getMedicalItemsList = () => {
    if (!medicalList || medicalList?.length <= 0) {
      return [];
    }
    return medicalList;
  };

  const _selectedMedicals = () => {
    const requested = _tempMedical || [];
    return requested.slice();
  };

  const _toggleItem = (item: string, isSelected: boolean) => {
    set_tempMedical((prevSelected) => {
      if (isSelected) {
        // Add the item to the selected list
        return [...prevSelected, item];
      } else {
        // Remove the item from the selected list
        return prevSelected.filter((selectedItem) => selectedItem !== item);
      }
    });
  };

  const _onDoneClicked = (component: any, isApplyAll = false) => {
    // Check if medicalList is available
    if (!medicalList) return;

    // Gather the selected medical conditions
    const selectedConditions: string[] = [];

    for (let i = 0; i < medicalList.length; i++) {
      const group = medicalList[i];
      const { conditions } = group;

      const selectedConditionsInGroup = conditions.filter((condition: string) =>
        _tempMedical.includes(condition)
      );

      selectedConditions.push(...selectedConditionsInGroup);
    }

    // Perform the necessary logic here to update the visit with the selected Medical services from the list
    onMedicalChange && onMedicalChange(selectedConditions, isApplyAll);
  };

  const _onChange = (condition: string) => {
    // If the condition clicked is already selected, deselect it
    if (_tempMedical.includes(condition)) {
      _toggleItem(condition, false);
     
    } else {
      // If the condition is not selected, select it
      _toggleItem(condition, true);

    }
  };

  const _renderListRow = (
    item: MedicalGroup,
    onClick: any,
    onMouseEnter: any,
    isSelectedGroup: boolean,
    isHovering: boolean,
  ) => {
    const { group_name, conditions } = item;

    const selectedImagestyle: React.CSSProperties = {
      display: "block",
    };

    const tdstyle: React.CSSProperties = {
      display: 'flex',
      flexDirection: 'column',
      minWidth: '150px',
      lineHeight: '40px',
      cursor: 'text',
    };

    const medicalgroupstyle: React.CSSProperties = {
      color: "#777777",
      fontSize: "12px",
      padding: '0 12px',
    };

    const medicalconditionstyle: React.CSSProperties = {
      padding: '0 12px',
      background: "transparent",
      color: "#4A4A4A",
      fontSize: "14px",
      cursor: 'pointer',
      
    };

    const groupstyle: React.CSSProperties = {
      borderBottom: "1px solid #F0F0F0",
      padding: "10px 0",
    };

    const isSelectedCondition = (condition: string) => _tempMedical.includes(condition);

    return (

      <div
      style = {groupstyle}
      >
        <div className="td-list" style={tdstyle}>
          <div style={medicalgroupstyle}>{group_name}</div>
          <div >
            {conditions &&
              Array.isArray(conditions) &&
              conditions.map((condition: string, index: number) => (

                <div
                  className={`td-item condition-list ${isSelectedCondition(condition) ? 'selected' : ''}`}
                  style={medicalconditionstyle}
                  key={`${group_name}-${index}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    _onChange(condition); // Pass a single condition, not an object
                  }}
                 
                  onMouseEnter={onMouseEnter}
                >
                  <span>{condition}</span>
                  {isSelectedCondition(condition) && (
                    <img src="/check_circle.svg" alt="" className={"td-selected-icon"} style={selectedImagestyle} />
                  )}

                </div>

              ))}
          </div>
        </div>
      </div>
    );

  };
  // Use the provided "medical_conditions" as initially selected conditions
  useEffect(() => {
    if (medical_conditions && medical_conditions.length > 0) {
      set_tempMedical(medical_conditions);
    }
  }, [medical_conditions]);
  const _toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const hasMedicalConditions = _getMedicalItemsList().length > 0;
  const shouldRenderComponent = value != "hard";
  const showmedicalcondition = !hidemedical;
  if (showmedicalcondition) {

    return shouldRenderComponent ? (
      <div className={`${props.className} v`}>
        {props.children}

        <TextDropdown
          hidden={props.hidden}
          className={props.tdClassName}
          inputClassName={props.tdInputClassName}
          items={_getMedicalItemsList()}
          readOnly
          hideFocusBar
          multiSelection
          showSelectionTick
          popupAlignTop
          dontAnimate={props.dontAnimate}
          doneBtnText={props.doneBtnText}
          titleProperty="name"
          dropdownColor="#4a4a4a"
          popupWidth="433px"
          popupHeight="307px"
          placeholder={hasMedicalConditions ? "Medical Conditions" : "Medical Conditions"}
          disabled={!hasMedicalConditions}
          selectedItems={_tempMedical || medical_conditions || []}
          renderItemFn={_renderListRow}
          onChange={(item: string) => {
            _toggleDropdown(); // Close the dropdown when an item is selected
            _onChange(item); // Call the original _onChange function
          }}
          onBlur={_onDoneClicked}
          onApplyAll={
            !props.showApplyAll
              ? UNDEF
              : (component: any) => _onDoneClicked(component, true)
          }
        />
        {
          hasMedicalConditions ?
            <div className="h grow medical-condition-subtext">
              <Txt className="nvd-text no-shrink">
                Select only if CR has medical conditions that requires matching with experienced CPs
              </Txt>
            </div> :
            <div className="h grow medical-condition-subtext">
              <Txt className="nvd-text no-shrink">
                Only applicable for CRs with whitelisted medical condition(s)
              </Txt>
            </div>
        }

        <Div className="h wrap" mt={-3}>
          {_selectedMedicals().map((item: string) => {
            return (
              <div
                className={"chip" + (isViewOnly ? " chip-no-cross" : "")}
                key={item}
              >
                {item === OTHERS ? "Others: " + props.othersValue : item}
                <img
                  tabIndex={0}
                  src="/close.svg"
                  alt=""
                  className="chip-delete"
                  onClick={() => _deleteMedical(item)}
                  onKeyUp={(e: any) => e.key === "Enter" && _deleteMedical(item)}
                />
              </div>
            );
          })}
        </Div>

      </div>
    ) : (

      <div className="vd-therapy-disabled h center medicalconditiondisable" >
        Not applicable for Hard PCP visits
      </div>
    );
  }
  else {
    return shouldRenderComponent ? (

      <div className={`${props.className} v`}>
        <Div className="h wrap" mt={-3}>
          {hasMedicalConditions ? (
            _selectedMedicals().map((item: string) => (
              <div
                className={"chip" + (isViewOnly ? " chip-no-cross" : "")}
                key={item}
              >
                {item === OTHERS ? "Others: " + props.othersValue : item}
                <img
                  tabIndex={0}
                  src="/close.svg"
                  alt=""
                  className="chip-delete"
                  onClick={() => _deleteMedical(item)}
                  onKeyUp={(e: any) => e.key === "Enter" && _deleteMedical(item)}
                />
              </div>
            ))
          ) : (
            <div className="vd-therapy-disabled h center medicalconditiondisable">
              Only applicable for CRs with whitelisted medical condition(s)
            </div>
          )}
        </Div>


        {props.children}

        <TextDropdown
          hidden={props.hidden}
          className={props.tdClassName}
          inputClassName={props.tdInputClassName}
          items={_getMedicalItemsList()}
          readOnly
          hideFocusBar
          multiSelection
          showSelectionTick
          popupAlignTop
          dontAnimate={props.dontAnimate}
          doneBtnText={props.doneBtnText}
          titleProperty="name"
          dropdownColor="#4a4a4a"
          popupWidth="433px"
          popupHeight="307px"
          placeholder={hasMedicalConditions ? "+ Add a medical condition" : ""}
          disabled={!hasMedicalConditions}
          selectedItems={_tempMedical || medical_conditions || []}
          renderItemFn={_renderListRow}
          onChange={(item: string) => {
            _toggleDropdown(); // Close the dropdown when an item is selected
            _onChange(item); // Call the original _onChange function
          }}
          onBlur={_onDoneClicked}
          onApplyAll={
            !props.showApplyAll
              ? UNDEF
              : (component: any) => _onDoneClicked(component, true)
          }
        />
      </div>
    ) : (
      <div className="vd-therapy-disabled h center medicalconditiondisable">
        Not applicable for Hard PCP visits
      </div>
    );
  }
};

export default MedicalServices;